import styled from 'styled-components';

export const Container = styled.div`
  /* padding-bottom: 32px; */
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : '1172px')};
  width: ${(props) => (props.width ? props.width : '1172px')};
  min-height: ${(props) => props.minHeight ?? 'calc(100vh - 216px)'};
  height: ${(props) => props.height ?? '100%'};
  background: white;
  border: 1px solid #b1b3b3;
  box-shadow: 0px 4px 8px -2px rgba(77, 77, 77, 0.1),
    0px 2px 4px -2px rgba(77, 77, 77, 0.06);
  border-radius: 8px;
  padding: 32px;
  box-sizing: border-box;
  margin: ${(props) => props.margin ?? '40px auto'};

  > p {
    color: #4d4d4d;
    margin: 0;
  }

  @media (max-width: 1172px) {
    width: 98vw;
    height: calc(100vh - 124px);
  }

  @media (max-width: 1024px) {
    width: 98vw;
    height: calc(100vh - 156px);
  }

  @media (max-width: 767px) {
    height: fit-content;
    margin-top: 100px !important;
  }
`;

export const PageContainer = styled.div`
  background-color: #d9d9d9;
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const PageTitle = styled.h1`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: ${({ tema }) => tema?.primaryColor ?? '#1d3054'};
  margin: 0;
  margin-bottom: 8px;
`;
